<template>
    <div>

        <iframe v-if="isYoutube" width="576" height="324" :src="source" frameborder="0" allowfullscreen class="partial-video"></iframe>

        <video v-if="isPrivate" class="partial-video video-js vjs-default-skin vjs-big-play-centered vjs-16-9" :class="{ nocontrol: !controllable }" width="576" height="324" ref="videojs">
            <p class="vjs-no-js">Deze video kan niet afgespeeld worden.</p>
        </video>

    </div>
</template>


<script>
import autoValidate from './autoValidateMixin'
import videojs from 'video.js'
import videoJsResolutionSwitcher from 'videojs-resolution-switcher'
import storage from 'js/api/storage'

export default {
    mixins: [
        autoValidate
    ],
    data: function() {
        return {
            videojsDestroy: () => {}
        }
    },
    computed: {
        isYoutube: function() {
            return this.partial.data.type === 'youtube'
        },
        isPrivate: function() {
            return this.partial.data.type === 'private'
        },
        source: function() {
            var append = ''
            var id = this.partial.data.id
            if ( 'playlist' in this.partial.data ) {
                id = this.partial.data.playlist[0]
                append += this.partial.data.playlist.slice(1).reduce( (sum, el) => sum += ',' + el, '&playlist=')
            }

            return '//www.youtube-nocookie.com/embed/' + id + '?rel=0' + append
        },
        controllable: function() {
            return this.partial.data.controllable !== false
        },
        volume: {
            get: () => storage.local.getItem('videoVolume'),
            set: val => storage.local.setItem('videoVolume', val)
        },
        mute: {
            get: () => storage.local.getItem('videoMute') === 'true',
            set: val => storage.local.setItem('videoMute', val)
        },
    },

    methods: {

        flush: function() {
            return Promise.resolve()
        },

        initVideojs: function(el) {
            const vm = this

            const opts = {
                controls: true,
                // poster: 'myPoster.jpg',

                autoplay: false,
                preload: 'auto',
                language: 'nl',
                techOrder: [ 'html5' ],
                controlBar: {
                    volumeMenuButton: {
                        inline: false
                    }
                },
                plugins: {
                    videoJsResolutionSwitcher: {
                        default: 'low'
                    }
                }
            }

            videojs(el, opts, function() {

                var player = this

                player.updateSrc(vm.partial.data.sources)

                if (vm.volume != null) {
                    player.volume(vm.volume);
                }

                if (vm.mute != null) {
                    player.muted(vm.mute);
                }

                player.on('volumechange', () => {
                    vm.volume = player.volume()
                    vm.mute = player.muted()
                })

                if ( ! vm.controllable ) {
                    player.controlBar.progressControl.seekBar.off('mousedown')
                    player.controlBar.progressControl.seekBar.off('touchstart')
                    player.controlBar.progressControl.seekBar.off('click')
                    player.controlBar.playToggle.off('click')
                    player.controlBar.playToggle.off('touchstart')
                    player.controlBar.playToggle.off('mousedown')
                }


                // set destroy handler when comonent is destroyed
                vm.videojsDestroy = () => player.dispose()

            });
        }
    },
    created: function() {

        if ( this.isPrivate ) {
            this.$nextTick( () => {
                this.initVideojs(this.$refs.videojs)
            })
        }

    },
    beforeDestroy: function() {
        this.videojsDestroy()
    },

}
</script>


<style lang="scss">

    @import 'global';

    // make sure font import can be found by webpack
    // https://github.com/webpack-contrib/sass-loader#problems-with-url
    $icon-font-path: "~videojs-font/fonts/";
    @import 'video.js/src/css/video-js';
    @import 'videojs-resolution-switcher/lib/videojs-resolution-switcher';

    .partial-video {

        /**
         *  Custom style
         */

        $video-font-size: 12px;
        font-size: $video-font-size;
        background-color: $color-light-grey;


        &.vjs-fullscreen {
            margin: 0 !important;
            background-color: #000;
        }

        .vjs-resolution-button {
            color: $color-white;
            // decrease icon size
            .vjs-resolution-button-staticlabel:before  {
                font-size: 1.6 * $video-font-size; // cannot use em here since in IE11 relative font-sizes are stacked
                line-height: 1.9;
            }
        }

        // change progress margin to parent class
        .vjs-progress-control {
            margin: 0 0.5em 0 0.5em;
        }
        .vjs-progress-holder {
            margin: 0;
        }

        // slider color
        .vjs-slider {
            background-color: transparentize($color-white, 0.8)
        }
        .vjs-load-progress {
            background-color: transparentize($color-white, 0.6)
        }

        // rounded play button
        $big-play-button-size: 2em;
        .vjs-big-play-button {
            line-height: $big-play-button-size - 0.1em;
            height: $big-play-button-size;
            width: $big-play-button-size;
            border-radius: 50%;
        }
        &.vjs-big-play-centered .vjs-big-play-button {
            margin-top: -0.5*$big-play-button-size;
            margin-left: -0.5*$big-play-button-size;
        }

        // increase menu button padding
        .vjs-menu li {
            padding-top: 0.8em;
            padding-bottom: 0.8em;
        }

        // prevent taps on hidden control bar
        &.vjs-has-started.vjs-user-inactive.vjs-playing .vjs-control-bar {
            pointer-events: none;
        }

        // Disable time controls
        &.nocontrol {
            &.vjs-playing .vjs-tech {
                pointer-events: none;
            }

            .vjs-slider {
                cursor: not-allowed;
            }

            .vjs-play-control {
                display: none;
            }

        }

    }

</style>



// WEBPACK FOOTER //
// VideoPartial.vue?740e30db